import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

const Link = styled(RouterLink)`
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.2px;
  text-align: left;
  color: ${(props) => props.theme.COLOR_LINK};
  font-weight: 700;
`;

const StyledLink = {
  Link,
};

export default StyledLink;
